import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { datePickerFooterStyles } from './styles/date-picker-footer.styles';
import type { DatePickerFooterPropsInterface } from './types/date-picker-footer.types';

/**
 * @since 10.0.0
 */
export const DatePickerFooter = forwardRef<HTMLDivElement, DatePickerFooterPropsInterface>(
  (props: DatePickerFooterPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(datePickerFooterStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="DatePicker.Footer"
        className={cx('c11n', 'c11n_date-picker__footer', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DatePickerFooter.displayName = 'DatePicker.Footer';
